import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Auth } from '@aws-amplify/auth';
import {
  NbActionsModule,
  NbButtonModule,
  NbContextMenuModule,
  NbIconModule,
  NbMenuService,
  NbSidebarService,
  NbUserModule
} from '@nebular/theme';
import { Store } from '@ngxs/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { RouterState } from 'src/app/features/auth/redux';
import { ENVIRONMENT } from 'src/environments/environment';
import { LayoutService } from '../utils/layout.service';

@Component({
  selector: 'app-header',
  styleUrls: ['./header.component.css'],
  templateUrl: './header.component.html',
  imports: [NbIconModule, NbActionsModule, NbUserModule, NbContextMenuModule, NbButtonModule]
})
export class HeaderComponent implements OnInit, OnDestroy {
  public username$: Observable<string> = inject(Store).select(RouterState.username);
  private unsubscribe = new Subject<void>();

  public title = ENVIRONMENT.appName + ' - ' + ENVIRONMENT.name;
  public username = null;
  public compact = false;

  public userMenu = [{ title: $localize`Log out`, icon: 'log-out-outline' }];

  constructor(
    private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private layoutService: LayoutService
  ) {}

  public ngOnInit() {
    this.username$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => (this.username = data));
    this.menuService
      .onItemClick()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((event) => {
        if (event.item.title === $localize`Log out`) {
          this.logOut();
        }
      });
  }

  public async logOut() {
    try {
      await Auth.signOut();
    } catch (error) {
      console.log('error signing out: ', error);
    }
  }

  public ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public toggleSidebar(): boolean {
    this.compact = !this.compact;
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  public navigateHome() {
    this.menuService.navigateHome();
  }
}
